module.exports = __webpack_public_path__ + "static/media/cod-logo-white.9afc0f8f.svg";